import { Divider } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { IApplicationState } from '../../../store';
import { useAudienceEmails } from '../../../utilities/hooks/useAudienceEmails';
import { Label, LabelAbove } from '../../common';
import { SurveyLink } from '../SurveyLink';

const SurveyLinkContainer = styled.div`
	padding-top: 40px;
`;
SurveyLinkContainer.displayName = 'SurveyLinkContainer';

export const SingleLinkWithoutDistribution = () => {
	const { audience } = useSelector((state: IApplicationState) => state.audienceDetails);
	const { isMultiLanguageSurvey, Toast } = useAudienceEmails(audience.audienceId, audience.surveyId);

	return (
		<>
			<Label size='md' className='tws-label'>
				{ContentConstants.DISTRIBUTIONOPTIONS_SINGLE_LINK_USER_DESCRIPTION}
			</Label>
			<LabelAbove type='input' textIsHtml={true} text={ContentConstants.INSTRUCTIONALTEXT_DISTRIBUTION_SINGLE_LINK_USER} />
			<Divider type='dashed' />
			<SurveyLinkContainer>
				<SurveyLink toast={Toast} surveyLinkId={audience.surveyLinkId} labelSize='lg' isMultiLanguageSurvey={isMultiLanguageSurvey} />
			</SurveyLinkContainer>
		</>
	);
};
